import Vue from 'vue'
import {HTTP} from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import {UserRoleEnum} from '@/enums/userRolesEnum'
import {Certification, IssuableController} from "@/components/provider/cards/issuables/IssuableModels";
import {getRestParamErrorMessage} from "@/utils/serverErrorMessageUtil";
import CertificationDetail from "@/components/provider/cards/certifications/CertificationDetail";
import IssuableCard from "@/components/provider/cards/issuables/IssuableCard";

export default Vue.component('provider-certifications-card', {
  name: 'ProviderCertificationsCard',
  data() {
    return {
      loadingSecondaryData: false,
      systemCertifications: [],
    }
  },
  components: {
    IssuableCard,
    VueSimpleSpinner,
    CertificationDetail
  },
  computed: {
    isProviderUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.PROVIDER)
    }
  },
  created() {
    this.getSystemCertifications();
  },
  methods: {
    getSystemCertifications () {
      if (this.isProviderUser) {
        return;
      }
      let self = this;
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingSecondaryData = true;
      }, 0);
      HTTP.get('/api/certificationTypes')
        .then(function (response) {
          clearTimeout(showLoadingSpinnerTimeout);
          self.loadingSecondaryData = false;
          if (!response.data || !response.data.data) {
            throw new Error("Error retrieving Certifications.");
          }
          self.systemCertifications = response.data.data;
        })
        .catch(function (err) {
          console.log('response Error! ' + err);
          clearTimeout(showLoadingSpinnerTimeout);
          self.loadingSecondaryData = false;
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: 'An error occurred retrieving System Certifications.'
          });
        })
    },

    issuableController() : IssuableController<Certification> {
      return {

        entityName: "Certification",
        entityType: 2,
        documentUploadPath: "provider/certification/",
        primaryIdField: "certificationId",
        createNewModel(providerId: string): any {
          return {
            providerId: providerId,
            certificationId: null,
            certificationName: "",
            certificationShortName: "",
            issuedDate: null,
            expirationDate: null,
            expirationNoticeDate: null,
            expirationNoticeSetting: 0,
            isNew: true,
            isEditing: true
          }
        },
        getAllForProvider(providerId: string): Promise<any> {
          return HTTP.get('/api/providers/' + providerId + '/certifications')
        },
        createData(providerId: string, issuable: Certification): Promise<any> {
          return HTTP.post('/api/providers/' + providerId + '/certifications', issuable)
        },
        deleteData(providerId: string, id: number): Promise<any> {
          return HTTP.delete('/api/providers/' + providerId + '/certifications/' + id);
        },
        deleteDocument(id: number): Promise<any> {
          return HTTP.delete('/api/facilityCertificationDocument/' + id )
        },
        errorsExistOnDynamicFields(issuable: Certification): boolean {
          return issuable.certificationTypeIdErrorMessage.length > 0;
        },
        setErrorsOnDynamicFields(issuable: Certification, error: any): void {
          issuable.certificationTypeIdErrorMessage = getRestParamErrorMessage(error, 'certificationTypeId');
        },
        updateData(providerId: string, issuable: Certification): Promise<any> {
          return HTTP.put('/api/providers/' + providerId + '/certifications', issuable);
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/provider/cards/certifications/CertificationsCard.ts